module.exports = __webpack_public_path__ + "img/178.a0fc885c.jpg";